import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import SyncStatus from "../../components/SyncStatus/SyncStatus";
import "./SyncPage.scss";

function SyncPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const sessionId = location.state?.sessionId || null;
  const videoFileName = location.state?.videoFileName || "AV_Sync_Output";

  // If no sessionId, redirect back to upload
  useEffect(() => {
    if (auth.isAuthenticated && !sessionId) {
      navigate("/upload", { replace: true });
    }
  }, [auth.isAuthenticated, sessionId, navigate]);

  const handleGoToDownload = () => navigate("/download", { state: { sessionId, videoFileName } });

  const email = auth.user?.profile?.email || auth.user?.profile?.sub || "User";

  return (
    <div className="syncp-page">
      <main className="tab-panel">
        <SyncStatus
          sessionId={sessionId}
          onGoToDownload={handleGoToDownload}
          onBack={() => navigate("/upload")}
          userEmail={email}
        />
      </main>
    </div>
  );
}

export default SyncPage;
